import { RequiredOmcProductMarketShareSummaryData } from '../response/omc-demand-submissions.response';

export interface RequestState<T = any> {
  loading: boolean;
  response: T | null;
  error: any;
  message?: string | null;
}

export interface OmcManagementState {
  omcList: RequestState<any[]>;
  omcContractsList: RequestState<any[]>;
  omcDemandSubmissions: RequestState<any>;
  omcDemandCycles: RequestState<any>;
  omcActiveOpenDemandCycles: RequestState<any>;
  omcDemandCycleByUuid: RequestState<any>;
  omcDemandByUuid: RequestState<any>;
  omcCurrentWindowDemandDraft: RequestState<any>;
  omcDraftDemand: RequestState<any>;
  omcDemandProjection: RequestState<any>;
  omcTransitConsignees: RequestState<any>;
  omcTransitStocks: RequestState<any>;
  omcSubmitDemand: RequestState<any>;
  omcDeleteDemandDraft: RequestState<any>;
  omcRequiredGuaranteeSummary: RequestState<any>;
  omcProductMarketShareSummary: RequestState<RequiredOmcProductMarketShareSummaryData>;

  omcOverduePendingBillsSummary: RequestState<any>;
  omcTerminalAgreements: RequestState<any>;
  omcTerminalAgreementByUuid: RequestState<any>;
  omcStockReports: RequestState<any>;
  omcStockReportDetail: RequestState<any>;
  omcCreateStockReport: RequestState<any>;
  omcUpdateStockReport: RequestState<any>;
  omcSubmitStockReport: RequestState<any>;
  omcSubmitUsageReport: RequestState<any>;
  omcUpdateUsageReport: RequestState<any>;
  omcCreateTerminalAgreement: RequestState<any>;
  omcUpdateTerminalAgreement: RequestState<any>;
  omcSubmitTerminalAgreement: RequestState<any>;
  omcTerminalSameTin: RequestState<any>;
  omcSignContract: RequestState<any>;
  omcCertificatePreview: RequestState<any>;
  loggedInOmcLastMonthsProjects: RequestState<any>;
  bpsCalendar: RequestState<any>;
  deleteOmcDemandCargoProduct: RequestState<any>;
  deleteOmcDemandProductUsage: RequestState<any>;
}

const baseState = { loading: false, response: null, error: null, message: null };

export const initialOmcManagementState: OmcManagementState = {
  omcList: { ...baseState },
  omcContractsList: { ...baseState },
  omcDemandSubmissions: { ...baseState },
  omcDemandCycles: { ...baseState },
  omcActiveOpenDemandCycles: { ...baseState },
  omcDemandCycleByUuid: { ...baseState },
  omcDemandByUuid: { ...baseState },
  omcCurrentWindowDemandDraft: { ...baseState },
  omcDraftDemand: { ...baseState },
  omcDemandProjection: { ...baseState },
  omcTransitConsignees: { ...baseState },
  omcTransitStocks: { ...baseState },
  omcSubmitDemand: { ...baseState },
  omcDeleteDemandDraft: { ...baseState },
  omcRequiredGuaranteeSummary: { ...baseState },
  omcProductMarketShareSummary: { ...baseState },
  omcOverduePendingBillsSummary: { ...baseState },
  omcTerminalAgreements: { ...baseState },
  omcTerminalAgreementByUuid: { ...baseState },
  omcStockReports: { ...baseState },
  omcStockReportDetail: { ...baseState },
  omcCreateStockReport: { ...baseState },
  omcUpdateStockReport: { ...baseState },
  omcSubmitStockReport: { ...baseState },
  omcSubmitUsageReport: { ...baseState },
  omcUpdateUsageReport: { ...baseState },
  omcCreateTerminalAgreement: { ...baseState },
  omcUpdateTerminalAgreement: { ...baseState },
  omcSubmitTerminalAgreement: { ...baseState },
  omcTerminalSameTin: { ...baseState },
  omcSignContract: { ...baseState },
  omcCertificatePreview: { ...baseState },
  loggedInOmcLastMonthsProjects: { ...baseState },
  bpsCalendar: { ...baseState },
  deleteOmcDemandCargoProduct: { ...baseState },
  deleteOmcDemandProductUsage: { ...baseState },
};
